export default __webpack_public_path__ + "static/media/beat7.d13d9048.mp3";